//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $$ from 'jquery'
import moment from 'moment';
import 'moment/locale/zh-cn';
import Header from '../header/header.vue'
import Footer from '../footer/footer.vue'
import { areaData } from "../../util/areaDataAntd"
import { Toast } from 'vant';
import quoLoginModule from "./quoLoginModule"
import Clipboard from 'clipboard';
export default {
  name: 'preview',
  data () {
    return {
      userInfo: this.$store.getters.getUserInfo, // 登录用户信息
      form: this.$form.createForm(this, 'form'),
      designOrderInfo: {},
      DPI_X: 72,
      DPI_Y: 72,
      MAX_HEIGHT: 40,
      MIN_HEIGHT: 30,
      MAX_WIDTH: 450,
      provinces: areaData,
      formValues: {},
      selectedAreas: []
    }
  },
  components: {
    Header,
    Footer,
    quoLoginModule
  },
  computed: {

  },
  methods: {
    fnCountAdditionOrterMoney () {
      var allAddPrice = 0
      if (this.designOrderInfo.designOrderAdditionOrtherList && this.designOrderInfo.designOrderAdditionOrtherList.length > 0) {
        this.designOrderInfo.designOrderAdditionOrtherList.forEach(add => {
          allAddPrice += add.allPrice
        })
      }
      return allAddPrice / 100
    },
    fnCountDetailAllMoney () {
      var allPrice = 0
      if (this.designOrderInfo.childDesignOrderDetails && this.designOrderInfo.childDesignOrderDetails.length > 0) {
        this.designOrderInfo.childDesignOrderDetails.forEach(detail => {
          allPrice += (parseFloat(detail.prodAllPrice) + parseFloat(detail.additionAllPrice))
        })
      }
      return allPrice / 100
    },
    handleAreaChanged (e, areas) {
      this.selectedAreas = areas
    },
    handleBtnSaveQuotationClicked () {
      if (this.userInfo && this.userInfo.id) {
        this.form.validateFields((err, values) => {
          if (!err) {
            // 保存报价方法
            // console.log('userInfo===>', this.userInfo)
            this.formValues = values
            var ucQuotation = this.fnInitQuotationInfo(1)
            // console.log('ucQuotation===>', ucQuotation)
            this.fnCommitUcQuotationInfo(ucQuotation)
          } else {
            Toast("您有信息未填写或填写错误")
          }
        })
      } else {
        // 用户未登录，打开弹出层，输入用户手机号
        this.$refs.quoLoginModule.showLogin()
      }
    },
    handleBtnCopyClicked () {
      const btnCopy = new Clipboard('.btn')
      btnCopy.on('success', e => {
        Toast('复制成功')
        // 释放内存
        btnCopy.destroy()
      })
      btnCopy.on('error', e => {
        // 不支持复制
        Toast('该浏览器不支持自动复制')
        // 释放内存
        btnCopy.destroy()
      })
    },
    fnExportUcQuotationExcel () {
      var ucQuotation = this.fnInitQuotationInfo(0)
      this.$store.dispatch('quotation/exportUcQuotationExcelAi', JSON.stringify(ucQuotation))
        .then(res => {
            console.log('fnExportUcQuotationExcel res ===>', res)
            let blob = new Blob([res.data], { type: 'APPLICATION/OCTET-STREAM;charset=UTF-8' });
            let url = window.URL.createObjectURL(blob);
            console.log('fnExportUcQuotationExcel url ===>', url)
            const link = document.createElement('a'); // 创建a标签
            link.href = url;
            link.download = '【' + this.designOrderInfo.companyName + '】' + this.designOrderInfo.projectName + '报价单.xlsx'; // 重命名文件
            link.click();
            URL.revokeObjectURL(url); // 释放内存
        }).catch(err => {
          console.log('err===>', err)
        })
    },
    fnCommitUcQuotationInfo (ucQuotation) {
      this.$store.dispatch('quotation/saveUcQuotationAi', JSON.stringify(ucQuotation))
        .then(res => {
          if (res.data && res.data.retCode == 1) {
            Toast("操作成功")
            this.$router.replace({
              path: '/caseDetail',
              query: {projectId:this.designOrderInfo.projectId}
            })
          } else {
            Toast(res.retMsg)
          }
        }).catch(err => {
          console.log('err===>', err)
        })
    },
    fnInitQuotationInfo (isSave) {
      var ucQuotation = this.fnInitUcQuotation(isSave)
      // 附件信息
      ucQuotation.ccFileInfoBo = this.fnInitCcFileInfoBo()
      // 方案信息明细集合
      ucQuotation.ucQuotationProdBoBos = this.fnInitUcQuotationProdBoBos()
      // 方案选项信息
      ucQuotation.ucQuotationOrtherBoBos = this.fnInitUcQuotationOrtherBos()
      return ucQuotation;
    },
    fnInitUcQuotation (isSave) {
      var ucQuotation = {
        /** 用户ID */
        userId: this.userInfo.id,
        /** 用户名称 */
        optionUserName: this.userInfo.nickName,
        /** 企业ID */
        companyId: this.designOrderInfo.companyId,
        /** 企业名称 */
        companyName: this.designOrderInfo.companyName,
        /** 企业应用类型ID */
        appId: 'APP_XMPC',
        /** 报价单号 */
        quotationCode: this.designOrderInfo.bjdNum,
        /** 对应企业定制方案ID */
        projectId: this.designOrderInfo.projectId,
        /** 方案名称 */
        projectName: this.designOrderInfo.projectName,
        /** 对应平台最下级产品分类Id */
        sysProdTypeId: this.designOrderInfo.ccProdTypeId,
        /** 对应平台最下级产品分类名称 */
        sysProdTypeName: this.designOrderInfo.ccProdTypeName,
        /** 是否是自定义方案0否1是，若是则project_id=-1 */
        isCustom: 0,
        /** 报价方式0人工报价1AI报价 */
        quotationType: 1,
        /** 当前报价单状态说明0未提交1未报价2已报价3提交订单4作废5删除 */
        stateText: 2,
        /** 提交状态0未提交1提交 */
        submitState: 1,
        /** 报价状态0未报价1已经报价 */
        quotationState: 1,
        /** 生成订单状态0未生成1生成 */
        createOrderState: 0,
        /** 作废状态0有效1作废 */
        tovoidState: 0,
        /** 删除状态0未删除1删除 */
        delState: 0,
        /** 生成订单后对应的订单ID，不为空默认为-1 */
        orderId: '-1',
        /** 默认中华人民共和国 */
        country: '中国',
        /** 省 */
        // province: this.selectedAreas[0].label,
        // /** 市 */
        // city: this.selectedAreas[1].label,
        // /** 区 */
        // area: this.selectedAreas[2].label,
        /** 国家编号-1默认中国 */
        countryCode: '100000',
        /** 省编号 */
        // provinceCode: this.selectedAreas[0].value,
        // /** 市编号 */
        // cityCode: this.selectedAreas[1].value,
        // /** 区编号 */
        // areaCode: this.selectedAreas[2].value,
        /** 配送地址 */
        // address: this.formValues.address,
        /** 报价总金额存分=产品+其它+配送安装 */
        quotationMoney: this.designOrderInfo.money,
        /** 调整优惠金额存分 */
        discountMoney: 0,
        /** 最终报价金额=报价总金额-调整优惠金额 存分 */
        lastMoney: this.designOrderInfo.money,
        /** 产品总金额存分 */
        prodMoney: this.fnCountDetailAllMoney() * 100,
        /** 其它费用金额存分 */
        ortherMoney: this.fnCountAdditionOrterMoney() * 100,
        /** 配送安装费用存分 */
        installMoney: 0,
        /** 期望到货起始时间 */
        // arrivalStartTime: this.formValues.arrivalTimeRange[0].format('YYYY-MM-DD') + ' 00:00:00',
        /** 期望到货截止时间 */
        // arrivalEndTime: this.formValues.arrivalTimeRange[1].format('YYYY-MM-DD') + ' 23:59:59',
        /** 制作要求 */
        // requirement: this.formValues.requirement,
        /** 是否通过供需创建0否1是 */
        isRefCustom: 0,
        /** 供需表ID */
        demandId: '-1',
        /** 收货人姓名 */
        // linkName: this.formValues.linkName,
        /** 收货人联系方式 */
        // linkPhone: this.formValues.linkPhone,
        /** 报价时间 */
        quotationTime: '',
      }
      if (isSave == 1) {
        ucQuotation.linkName = this.formValues.linkName
        ucQuotation.linkPhone = this.formValues.linkPhone
        ucQuotation.requirement = this.formValues.requirement
        ucQuotation.arrivalStartTime = this.formValues.arrivalTimeRange[0].format('YYYY-MM-DD') + ' 00:00:00'
        ucQuotation.arrivalEndTime = this.formValues.arrivalTimeRange[1].format('YYYY-MM-DD') + ' 23:59:59'
        ucQuotation.province = this.selectedAreas[0].label
        ucQuotation.city = this.selectedAreas[1].label
        ucQuotation.area = this.selectedAreas[2].label
        ucQuotation.provinceCode = this.selectedAreas[0].value
        ucQuotation.cityCode = this.selectedAreas[1].value
        ucQuotation.areaCode = this.selectedAreas[2].value
        ucQuotation.address = this.formValues.address
      }
      return ucQuotation
    },
    fnInitCcFileInfoBo () {
      return {
        /** 企业ID */
        companyId: this.designOrderInfo.companyId,
        /** 关联应用ID */
        appId: 'APP_XMPC',
        /** 网络访问相对路径 */
        // url: 'http://www.xiaomecloud.com/server-cdr' + this.designOrderInfo.cdrUrl.split('server-cdr')[1],
        url: this.designOrderInfo.cdrUrl,
        /** 压缩后的小图片网络访问路径--只针对图片 */
        zipUrl: this.designOrderInfo.cdrUrl,
        /** 服务器物理存储路径 */
        disLocal: this.designOrderInfo.cdrFileDirPath,
        /** 压缩后的小图片服务器物理存储路径--只针对图片 */
        zipDisLocal: this.designOrderInfo.cdrFileDirPath,
        /** 图片的来源:参见字典filesource，这里存字典imem_value */
        fileSource: '00006',
        /** 附件类型，参见字典filetype,这里存字典imem_value */
        fileType: '00002',
        /** 文件后缀名，这里注意后缀名不带点 */
        fixName: '.cdr',
        /** 文件原始名称，注意文件名带后缀名 */
        fileName: this.designOrderInfo.cdrName,
        /** 提交文件用户 */
        userId: this.userInfo.id,
        /** 排序编号 */
        sort: 0,
        /** 图片是否使用，1是0非 */
        isUse: 1,
        /** 是否是外部文件 1是 0否 */
        isOut: 1
      }
    },
    fnInitProdImageFile (orderDetail) {
      return {
        /** 企业ID */
        companyId: this.designOrderInfo.companyId,
        /** 关联应用ID */
        appId: 'APP_XMPC',
        /** 网络访问相对路径 */
        // url: 'http://www.xiaomecloud.com/server-cdr' + orderDetail.msImageUrl.split('server-cdr')[1],
        url: orderDetail.msImageUrl,
        /** 压缩后的小图片网络访问路径--只针对图片 */
        // zipUrl: 'http://www.xiaomecloud.com/server-cdr' + orderDetail.msImageUrl.split('server-cdr')[1],
        zipUrl: orderDetail.msImageUrl,
        /** 服务器物理存储路径 */
        disLocal: orderDetail.msDirPath,
        /** 压缩后的小图片服务器物理存储路径--只针对图片 */
        zipDisLocal: orderDetail.msDirPath,
        /** 图片的来源:参见字典filesource，这里存字典imem_value */
        fileSource: '00009',
        /** 附件类型，参见字典filetype,这里存字典imem_value */
        fileType: '00001',
        /** 文件后缀名，这里注意后缀名不带点 */
        fixName: '.png',
        /** 文件原始名称，注意文件名带后缀名 */
        fileName: orderDetail.msId + '.png',
        /** 提交文件用户 */
        userId: this.userInfo.id,
        /** 排序编号 */
        sort: 0,
        /** 图片是否使用，1是0非 */
        isUse: 1,
        /** 是否是外部文件 1是 0否 */
        isOut: 1
      }
    },
    fnInitUcQuotationProdBoBos () {
      var ucQuotationProdBoBos = []
      this.designOrderInfo.childDesignOrderDetails.forEach((orderDetail, index) => {
        var quotationProd = {
          /** 用户ID */
          userId: this.userInfo.id,
          /** 企业ID */
          companyId: this.designOrderInfo.companyId,
          /** 企业应用类型ID */
          appId: 'APP_XMPC',
          /** 对应平台产品名称 */
          prodName: orderDetail.prodName,
          /** 对应平台产品id */
          prodId: '-1',
          /** 对应SAAS产品ID，若不是AI报价这里为-1 */
          saasProdId: orderDetail.proId,
          /** 产品规格文字 */
          prodSpecStr: orderDetail.spec + orderDetail.priceUnitName,
          /** 长 */
          length: orderDetail.msPerimeter,
          /** 宽 */
          width: orderDetail.msWidth,
          /** 高/厚 */
          hieght: orderDetail.msHeight,
          /** 规格 */
          spec: orderDetail.spec,
          /** 长宽高单位字典值lwhunit */
          lwhUnitValue: '1',
          /** 长宽高单位字典名lwhunit */
          lwhUnitName: 'cm',
          /** 规格单位字典值specunit */
          specUnitValue: orderDetail.priceUnit,
          /** 规格单位字典名specunit */
          specUnitName: orderDetail.priceUnitName,
          /** 产品数量，默认是整数 */
          prodNum: orderDetail.num,
          /** 产品套数前期不使用默认1 */
          suitNum: 1,
          /** 单价默认存分，一个从产品的价格 */
          price: orderDetail.allPrice,
          /** 总价=单价*数量*套数，默认存分 */
          allPrice: orderDetail.allPrice,
          /** 排序编号 */
          sort: index,
          /** 产品选项字符串 */
          prodOption: this.fnGetUcQuotationDesignShowText(orderDetail.designOrderAdditions),
          /** 产品图片文件对象 */
          ccFileInfoBo: this.fnInitProdImageFile(orderDetail)
        }
        quotationProd.price = parseFloat(quotationProd.allPrice / quotationProd.prodNum / quotationProd.suitNum).toFixed(0)
        ucQuotationProdBoBos.push(quotationProd)
      })
      return ucQuotationProdBoBos
    },
    fnInitUcQuotationOrtherBos () {
      var ucQuotationOrtherBos = []
      this.designOrderInfo.designOrderAdditionOrtherList.forEach((addition, index) => {
        ucQuotationOrtherBos.push({
          /** 用户ID */
          userId: this.userInfo.id,
          /** 企业ID */
          companyId: this.designOrderInfo.companyId,
          /** 企业应用类型ID */
          appId: 'APP_XMPC',
          /** 附加选项组名称 */
          optionGroupName: addition.optionName,
          /** saas系统中对应的附加项组ID没有存-1 */
          saasOptionGroupId: addition.optionId,
          /** 附加选项名称 */
          optionName: addition.additionName,
          /** saas系统中对应的附加项组ID没有存-1 */
          saasOptionId: addition.additionId,
          /** 数量 */
          num: addition.additionNum,
          /** 单价存分 */
          price: addition.additionPrice,
          /** 总价=单价*数量*套数 */
          allPrice: addition.allPrice,
          /** 套数默认1前期不使用 */
          suitNum: 1,
          /** 备注 */
          remark: addition.remark,
          /** 排序编号 */
          sort: index
        })
      })
      return ucQuotationOrtherBos
    },
    fnGetUcQuotationDesignShowText (designOrderAdditions) {
      var showText = ''
      designOrderAdditions.forEach(addition => {
        showText += addition.optionName + ':' + addition.additionName + ';'
      })
      return showText
    },
    handleLognSucccess (userInfo) {
      // this.$router.go(0)
      this.userInfo = userInfo
      this.$refs.header.fnSetUserInfo(this.userInfo)
      this.handleBtnSaveQuotationClicked()
    },
    fnGetDpi () {
      if (window.screen.deviceXDPI) {
				this.DPI_X = window.screen.deviceXDPI;
				this.DPI_Y = window.screen.deviceYDPI;
			} else {
				var tmpNode = document.createElement("DIV");
				tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
				document.body.appendChild(tmpNode);
				this.DPI_X = parseInt(tmpNode.offsetWidth);
				this.DPI_Y = parseInt(tmpNode.offsetHeight);
				tmpNode.parentNode.removeChild(tmpNode);
			}
    },
    fnInitImageStyle (detail) {
      var imgWidth = parseFloat((detail.msWidth * 25.4) / this.DPI_X).toFixed(5)
      var imgHeight = parseFloat((detail.msHeight * 25.4) / this.DPI_Y).toFixed(5)
      var height, width
      if (imgHeight > this.MAX_HEIGHT) {
        height = this.MAX_HEIGHT
      } else if (imgHeight < this.MIN_HEIGHT) {
        height = this.MIN_HEIGHT
      } else {
        height = imgHeight
      }
      width = imgWidth * (height / imgHeight)
      if (width > this.MAX_WIDTH) {
        height = height * (this.MAX_WIDTH / width)
        width = this.MAX_WIDTH
      }
      return 'width: ' + width + 'px;height: ' + height + 'px;'
    },
    fnGetPhoneRegx () {
      // return /^[0-9]{11,13}$/
      return /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/
    },
    fnGetPrintObj () {
      return {
        id: "printDiv",//打印区域 Dom ID
        popTitle: '',
        extraCss: '',
        //  可以传进去  style tag 标签；注意要逗号分隔   解决特定区域不显示问题；
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>,<style> #printDiv { height: auto !important; padding-right: 10px; } html { zoom: 70% !important;} .cEm {display: none;} <style>'
      }
    },
    //跳转到平台首页
    fnGoToHomePage(e){
       this.fnStopBub(e);
       this.$router.push({path: '/home'});
    },
    //跳转到企业发布信息详情页
    fnGotoCompanyDetail(e){
      this.fnStopBub(e);
      this.$router.push({ path: '/companyDetailNew', query: { companyId : this.designOrderInfo.companyId ,inType:1} });
    }
  },
  mounted () {
    document.title = "AI报价结果预览"
    if (this.$route.params.designOrderJson) {
      this.designOrderInfo = JSON.parse(this.$route.params.designOrderJson)
      this.$nextTick(() => {
        this.form.setFields({
          'requirement': this.designOrderInfo.content
        })
      })
    } else {
      var designOrderJson = localStorage.getItem('designOrderJson');
      this.designOrderInfo = JSON.parse(JSON.parse(designOrderJson));
    }
    console.log('this.designOrderInfo ===>', this.designOrderInfo)
    this.designOrderInfo.childDesignOrderDetails.forEach(detail => {
      const image = new Image();
      // 解决跨域问题
      image.setAttribute("crossOrigin", "anonymous");
      image.src = detail.msImageUrl
      image.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        // eslint-disable-next-line no-undef
        context.drawImage(image, 0, 0, image.width, image.height);
        var quality = 0.8;
        // 这里的dataurl就是base64类型
        // 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
        const dataurl = canvas.toDataURL("image/png", quality);
        detail.imageBase64 = dataurl
        var imgObj = this.$refs['detail_image' + detail.msId]
        imgObj[0].src = dataurl
      }
    })
  },
  created () {
    moment.locale('zh-cn')
  },
}



// WEBPACK FOOTER //
// ./src/pages/product/preview.vue